<nav class="navbar navbar-expand-lg fixed-top">

  <div class="container-fluid">

    <div class="d-block d-lg-none nav-btn-block">
      <div class="fa menu-icon" [ngClass]="isShowMenu? 'fa-close':'fa-bars'" (click)="isShowMenu=!isShowMenu"></div>
    </div>

    <div class="logo-block">
      <a (click)="Navigate('/home')" class="logo">MPG PSR Platform</a>
    </div>

    <div class="d-none d-lg-flex lg-nav">

      <dx-menu 
        #menu 
        class="menu-block" 
        [dataSource]="menuItems" 
        displayExpr="name"
        [showFirstSubmenuMode]="submenuMode[0]" 
        orientation="horizontal"
        [hideSubmenuOnMouseLeave]="true" 
        itemTemplate="items"
      >
        <div *dxTemplate="let item of 'items'"> 
          <a class="menu-link" [ngClass]="isActive(item.url)?'active':''" (click)="Navigate(item.url)">
            {{item.name}}
            <span *ngIf="adminTotalNotificationCount && item.id=='admin'" class="notification-badge">{{adminTotalNotificationCount}}</span>
            <span *ngIf="adminManageReleaseDateNotificationCount && item.id=='manage-release-date'" class="notification-badge">{{adminManageReleaseDateNotificationCount}}</span>
          </a>
        </div>
      </dx-menu>

      <div class="user-info-block">

        <div class="user-block">
          <div class="user-icon fa fa-user"></div>
          <div class="user-label">{{userName}}</div>
        </div>
        

        <div class="sigin-out-block" (click)="signOut()">
          <div class="user-icon fa fa-sign-out"></div>
          <div class="user-label">Signout</div>
        </div>

      </div>
    
    </div>

    <div class="d-block d-lg-none sm-navbar-sec" *ngIf="isShowMenu" >
      <div class="side-navbar">
        <dx-menu 
          #menu 
          class="menu-block" 
          [dataSource]="menuItems" 
          displayExpr="name"
          [showFirstSubmenuMode]="submenuMode[1]" 
          orientation="vertical"
          [hideSubmenuOnMouseLeave]="false" 
          itemTemplate="items"
        >
          <div *dxTemplate="let item of 'items'"> 
            <a class="menu-link" [ngClass]="isActive(item.url)?'active':''" (click)="Navigate(item.url)">
              {{item.name}}
              <span *ngIf="adminTotalNotificationCount && item.id=='admin'" class="notification-badge">{{adminTotalNotificationCount}}</span>
              <span *ngIf="adminManageReleaseDateNotificationCount && item.id=='manage-release-date'" class="notification-badge">{{adminManageReleaseDateNotificationCount}}</span>
            </a>
          </div>
        </dx-menu>
  
        <div class="user-info-block">

          <div class="user-block">
            <div class="user-icon fa fa-user"></div>
            <div class="user-label">{{userName}}</div>
          </div>
          
  
          <div class="sigin-out-block" (click)="signOut()">
            <div class="user-icon fa fa-sign-out"></div>
            <div class="user-label">Signout</div>
          </div>
  
        </div>
  
      </div>
      <div class="blur-screen" (click)="isShowMenu=false"></div>
    </div>

  </div>

</nav>


